/**
 * Map Spanish backend `detail` strings to localized translation keys.
 * The backend currently returns user-facing auth errors in Spanish; this
 * helper localizes them on the client without changing the API contract.
 */
const ERROR_MAP = {
  "INVITE_CODE_REQUIRED": "auth.errors.inviteRequired",
  "Código de invitación requerido": "auth.errors.inviteRequired",
  "Código de invitación inválido": "auth.errors.inviteInvalid",
  "Este código de invitación ya fue utilizado": "auth.errors.inviteUsed",
  "Credenciales inválidas": "auth.errors.invalidCredentials",
  "Email ya registrado": "auth.errors.emailExists",
  "Apodo en uso": "auth.errors.nicknameInUse",
  "Sesión Emergent inválida": "auth.errors.googleSessionInvalid",
  "session_id requerido": "auth.errors.sessionRequired",
};

export function translateAuthError(detail, t) {
  if (!detail || typeof detail !== "string") return t("register.errors.generic");
  const key = ERROR_MAP[detail.trim()];
  return key ? t(key) : detail;
}
